import Vue from 'vue'
import i18n  from '@/i18n';
import App from '@/App.vue';
import Axios from 'axios';
import VueAxios from 'vue-axios';
import SuiVue from 'semantic-ui-vue';
import './../node_modules/semantic-ui-offline/semantic.min.css';

Vue.use(VueAxios, Axios);
Vue.use(SuiVue);

Vue.config.productionTip = false

new Vue({
  i18n,
  render: h => h(App)
}).$mount('#app')
